// profile.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { AuthStoreService, NavigationService } from '@app/shared/services';
import { ModalController } from '@ionic/angular/lazy';
import { SetupProfilePage } from '@app/features/setup/setup-profile/setup-profile.page';

/**
 * /member/my の is_complete が 0 の場合は「設定未完了」とみなし、
 * 追加設定のため SetupProfile をモーダルで表示する。
 * （/tabs/home 以外のルートに canActivate で付与し、home のみガードなしで許可する）
 */
export const profileGuard: CanActivateFn = async (
  _,
  state: RouterStateSnapshot
) => {
  const authStoreService = inject(AuthStoreService);
  const navigationService = inject(NavigationService);
  const modalController = inject(ModalController);

  const currentUser = await authStoreService.waitForCurrentUser();
  const isComplete = currentUser?.is_complete;
  if (isComplete === 0) {
    const presentingElement =
      document.querySelector('ion-router-outlet') ?? undefined;
    const modal = await modalController.create({
      component: SetupProfilePage,
      componentProps: { isModal: true },
      backdropDismiss: false,
      presentingElement,
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    if (data?.completed) {
      await navigationService.navigateToRoot(state.url);
    } else {
      await navigationService.navigateToRoot('/tabs/home');
    }
    return false;
  }
  return true;
};
